import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Steps, { Step } from 'rc-steps';
import './NavBar.scss';
var navSteps = [{
  title: 'Start',
  value: 'start'
}, {
  title: 'Description',
  value: 'description'
}, {
  title: 'Qualifications',
  value: 'qualifications'
}, {
  title: 'Budget & Logistics',
  value: 'budget & logistics'
}, {
  title: 'Preview',
  value: 'review'
}];
var sectionIndexMap = {
  start: 0,
  description: 1,
  'expertise-priority': 2,
  qualifications: 2,
  logistics: 3,
  budget: 3,
  'budget & logistics': 3,
  review: 4
};
function NavBar(_ref) {
  var activeSection = _ref.activeSection,
    handleUpdateSection = _ref.handleUpdateSection,
    projectResourceId = _ref.projectResourceId,
    validatedStep = _ref.validatedStep;
  var activeIndex = useMemo(function () {
    return sectionIndexMap[activeSection.trim()] || 0;
  }, [activeSection.trim()]);
  return /*#__PURE__*/React.createElement("div", {
    className: "project-nav-bar-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-none d-md-block px-4"
  }, /*#__PURE__*/React.createElement(Steps, {
    labelPlacement: "vertical",
    current: activeIndex
  }, navSteps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(Step, _extends({
      key: index,
      title: step.title
    }, projectResourceId && {
      onStepClick: handleUpdateSection(step.value)
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-sm-block d-md-none ps-4"
  }, /*#__PURE__*/React.createElement(Steps, {
    labelPlacement: "vertical",
    direction: "vertical",
    current: activeIndex
  }, navSteps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(Step, _extends({
      key: index,
      title: step.title
    }, projectResourceId && {
      onStepClick: handleUpdateSection(step.value)
    }));
  }))));
}
NavBar.propTypes = {
  activeSection: PropTypes.string.isRequired,
  handleUpdateSection: PropTypes.func.isRequired
};
export default NavBar;